import CloseIcon from '@mui/icons-material/Close';
import { ArrowRightIcon } from '@mui/x-date-pickers';
import { useAuthentication } from '@src/authentication/useAuthentication';
import type { ClientSummary } from '@src/clients/domain/Client';
import { isClientUser } from '@src/clientUser/useClientUser';
import { Button } from '@src/common/components/button/Button';
import { Divider } from '@src/common/components/Divider';
import { PageLayout } from '@src/common/components/Page';
import { Stack } from '@src/common/components/Stack';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import { ClientInformationSection } from '@src/orders/ClientInformationSection';
import { useOrderCreation } from '@src/orders/hooks/useOrderCreation';
import { Navigation } from '@src/routing/Navigation';
import { OrdersNavigation } from '@src/routing/OrdersNavigation';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const CreateOrder = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedClient, setSelectedClient] = useState<ClientSummary | null>(
    null,
  );
  const [selectedThirdPartyId, setSelectedThirdPartyId] = useState<
    string | undefined
  >(undefined);
  const [thirdPartyBilling, setThirdPartyBilling] = useState(false);
  const { user: currentUser } = useAuthentication();

  const { createOrder, isLoading: isCreatingOrder } = useOrderCreation({
    onSuccess: ({ orderId }) => {
      navigate(OrdersNavigation.addPermits.url(orderId));
    },
  });

  const returnToHome = () => {
    navigate(Navigation.home);
  };

  return (
    <PageLayout title={t('createOrder')}>
      <div style={{ marginTop: theme.spacing['6'] }}>
        <ClientInformationSection
          onClientChange={setSelectedClient}
          onThirdPartyChange={setSelectedThirdPartyId}
          onThirdPartyBillingChange={setThirdPartyBilling}
          isClientUser={isClientUser(currentUser)}
        />
      </div>

      <Divider
        style={{ marginBottom: theme.spacing['6'], marginTop: '40px' }}
      />

      <Stack direction="row" justifyContent="space-between">
        <Button type="button" className={button} onClick={returnToHome}>
          <CloseIcon style={{ marginRight: theme.spacing['2'] }} />
          {t('cancel')}
        </Button>

        <Button
          className={button}
          variant="contained"
          disabled={
            !selectedClient ||
            (!selectedThirdPartyId && thirdPartyBilling) ||
            isCreatingOrder
          }
          onClick={() => {
            createOrder({
              clientId: selectedClient!.id,
              billTo: selectedThirdPartyId,
            });
          }}
        >
          {t('create')}
          <ArrowRightIcon style={{ marginLeft: theme.spacing['2'] }} />
        </Button>
      </Stack>
    </PageLayout>
  );
};

const button = css({
  padding: '0 18px',
  height: '40px',
});
